
import React, {Component} from 'react';
import {Modal,Nav,NavItem,Row,Col,Button} from 'react-bootstrap'
import { Box } from 'reactjs-admin-lte'
import ReportWorkTable from './ReportWorkTable'
import ReportStore from '../../stores/ReportStore';
import FontAwesome from 'react-fontawesome'
class ReportCustomerHistoryModal extends Component {

  constructor(...args){
    super(...args)
    this.state = {actabTab:0,loading:false,data:[],stockData:[],customerName:''}
  }

  loadHistory(item){
    console.log('item',item)
    let that = this
    this.setState({loading:true,customerName:item.name,actabTab:0})
    ReportStore.loadCustomerWorkList(item.name,function(result){
      that.setState({data:result.data,loading:false})
    })
  }

  loadStockRecord(){
    let {customerName} = this.state
    let that = this
    this.setState({loading:true})
    ReportStore.loadCustomerStockRecordList(customerName,function(result){
      that.setState({stockData:result.data,loading:false})
    })
  }

  onTabSelect(activeKey){
    this.setState({actabTab:activeKey})

    if(activeKey===1){
      this.loadStockRecord()
    }
  }

  onRowWorkClick(workNo){

  }

  onPrintClick(recordid){
    //pdf/?sr=47&file=stockrecord_doc
    if (process.env.NODE_ENV == "development") {
      window.open('https://demo-fast.bigfix.co/sriracha/pdf/?sr='+recordid+'&file=stockrecord_doc')
    }else{
        window.open('./pdf/?sr='+recordid+'&file=stockrecord_doc', '_blank');
    }
  }

  getDayDurationText(item){
    let day = item.day_ago
    if(day==0){
      return (<span>รายการวันนี้ {item.show_date}</span>)
    }else if(day==1){
      return (<span>รายการวเมื่อวาน {item.show_date}</span>)
    }else if(day<30){
      return (<span>{item.show_date} {item.day_ago} วันที่แล้ว</span>)
    }else {
      return (<span>{item.show_date} {item.day_ago/30} เดือนที่แล้ว</span>)
    }
  }

  renderTab(){
    let {actabTab} = this.state
    return (
      <Nav bsStyle="tabs" activeKey={actabTab} onSelect={this.onTabSelect.bind(this)}>        
        <NavItem eventKey={0} >รายงานซ่อม</NavItem>
        <NavItem eventKey={1} >รายงานการซื้อขาย</NavItem>
      </Nav>
    )
  }

  renderEndOfRecord(){
    let {stockData} = this.state
    if(stockData.length>0){
      return (                 
         <li>
            <FontAwesome name='clock-o' className='bg-gray'/>              
         </li>
      )
    }else{
      return (
      <li className='time-label'>
         <span className="bg-gray">ไม่มีข้อมูล</span>
      </li>)
    }
  }

  renderTableRowItem(items){
    return items.map((item,index)=>(
      <tr key={index}>
        <td className='text-center'>{index+1}</td>
        <td>{item[2]}</td>
        <td className='text-center'>{item[3]}</td>
        <td className='text-right'>{item[4]}</td>
        <td className='text-right'>{item[5]}</td>
      </tr>
    ))
  }

  renderContent(){
    
    let {data,actabTab,stockData} = this.state
    return (
      <div>
        <div style={{display:(actabTab===0)?'block':'none'}}>
          <ReportWorkTable  data={data} showDetail={true} onRowWorkClick={this.onRowWorkClick.bind(this)}/>
        </div>
        <div style={{display:(actabTab===1)?'block':'none'}}>
          <Row>
            <Col md={12}>
              <ul className='timeline'>
                  {
                    stockData.map((item,index)=>{
                      return [
                        (<li  className='time-label'>
                          <span className="bg-green">{this.getDayDurationText(item)}</span>
                        </li>),
                        (
                          <li >
                              <FontAwesome name='money' className='bg-green'/>                     

                              <div className="timeline-item">
                              <span className="time"><i className="fa fa-clock-o"></i> {item.show_time}</span>

                              <h3 className="timeline-header"><a href="#">รวมทั้งหมด</a> {item.grand_total} บาท</h3>

                              <div className="timeline-body">
                                  <table className='table table-responsive table-hover table-bordered-solid'>
                                    <thead>
                                      <tr>
                                        <th style={{width:'50px'}} className='text-center'>ลำดับ</th>
                                        <th>รายการ</th>
                                        <th style={{width:'150px'}} className='text-center'>จำนวน</th>
                                        <th style={{width:'150px'}} className='text-center'>ราคาต่อหน่วย</th>
                                        <th style={{width:'150px'}} className='text-center'>รวม</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                        {this.renderTableRowItem(item.items)}
                                    </tbody>
                                  </table>
                                </div>
                                <div className="timeline-footer">
                                  <Button bsStyle='primary' onClick={this.onPrintClick.bind(this,item.recordid)}>พิมพ์รายการ</Button>                      
                                </div>
                              </div>
                          </li>
                        )
                      ]
                    })
                  }
                  {this.renderEndOfRecord()}
              </ul>
            </Col>
          </Row>
        </div>
      </div>
    )
  }

  render(){
    let {show} = this.props
    let {loading,customerName} = this.state
    return (
      <Modal show={show} enforceFocus={false} onHide={this.props.onHide} dialogClassName="midwidth-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{'ประวัติลูกค้า'+customerName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Box loading={loading}>
            <Box.Body>
              {this.renderTab()}    
              {this.renderContent()}          
            </Box.Body>           
          </Box>
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>   
    )
  }
}


export default ReportCustomerHistoryModal ;





// WEBPACK FOOTER //
// ./src/view/report/ReportCustomerHistoryModal.js